import React from "react";
import { Button } from "@/components/button";
import { Text } from "@/components/text";

export interface ModuleInfo {
  id: string;
  title: string;
  questionCount: number;
  currentModule?: boolean;
}

export interface ModuleNavigationModalProps {
  isOpen: boolean;
  onClose: () => void;
  modules: ModuleInfo[];
  currentModuleId: string;
  onModuleSelect: (moduleId: string) => void;
}

const ModuleNavigationModal: React.FC<ModuleNavigationModalProps> = ({
  isOpen,
  onClose,
  modules,
  currentModuleId,
  onModuleSelect,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-gray-900">Select Module</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-xl font-bold"
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="space-y-2 mb-6">
          {modules.map((module) => (
            <button
              key={module.id}
              onClick={() => {
                onModuleSelect(module.id);
                onClose();
              }}
              className={`w-full text-left p-3 rounded-lg border transition-colors cursor-pointer ${
                module.id === currentModuleId
                  ? "bg-blue-50 border-blue-300 text-blue-900"
                  : "bg-gray-50 border-gray-200 hover:bg-gray-100"
              }`}
            >
              <div className="font-medium">{module.title}</div>
              <Text className="text-sm text-gray-600">
                {module.questionCount} questions
              </Text>
            </button>
          ))}
        </div>

        <div className="flex justify-end">
          <Button
            onClick={onClose}
            className="bg-gray-500 hover:bg-gray-600 text-white"
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ModuleNavigationModal;
